import _ from "lodash"

export const fixEmptyObjectsInSubElements = (item: { [key: string]: any | any[] }) => {
    for (const [key, value] of Object.entries(item)) {
        try {
            if (typeof value === 'object' && _.isEmpty(value)) {
                _.set(item, key, null)
            } else if (Array.isArray(value)) {
                const newArray = value.filter(e => e !== undefined)
                newArray.forEach(e => fixEmptyObjectsInSubElements(e))
                newArray.forEach(e => fixEmptyObjectsInSubElements(e))
                _.set(item, key, newArray.filter(o => !(typeof o === 'object' && o !== null && _.isEmpty(o))))
            } else if (typeof value === 'object' && value !== null) {
                fixEmptyObjectsInSubElements(value)
            }
        } catch(err) {
            // logger (indicate that it happened in fixEmptyObjectsInSubElements)
            throw err
        }
    }
}

/**
 * Merges an updated version of a resource (as in ItemResource, MediaResource, ..., meaning the data transmitted
 * by or to the server) into the base version
 * @param base 
 * @param update 
 * @returns the merge of update in base
 */
export function mergeResource(base: any, update: any) {
    if(base === undefined) {
        return update
    }

    if(base === null) {
        if(update === undefined) {
            return null
        }
        return update
    }

    if(update === null) {
        return update
    }

    if(update === undefined) {
        return base
    }

    if(_.isArray(update)) {
        return update
    }

    /*if(_.isArray(base) && _.isArray(update)) {
        return _.zip(base, update).map(tuple => {
            return mergeResource(tuple[0], tuple[1])
        })   
    }*/

    if(_.isPlainObject(base) && _.isPlainObject(update)) {
        let keys = Object.keys(update)
        Object.keys(base).forEach((e) => keys.push(e))
        keys = _.uniq(keys)
        const mergeResult = {}

        for(const field of keys) {
            mergeResult[field] = mergeResource(base[field], update[field])
        }

        return mergeResult
    }

    return update
}

export const mergeOverridingArrays = (baseObject: Object, updates: Object) => {
    const util = (baseValue, updatedValue) => {
        if(_.isArray(baseValue) && _.isArray(updatedValue)) {
            return updatedValue
        }
    }

    return _.mergeWith(baseObject, updates, util)
}
    